import { Step } from "@storebrand-digital/insurance-stepper";
import { CHECKOUT_STEPS } from "Components/Features/CheckOut/checkoutSteps";
import { TextManager } from "Components/TextContext";
import { MainPath } from "Constants/constants";

const { getText } = TextManager;

export const HOUSE_CONTENTS_INTRO_STEP: Step = {
  id: "din-innboforsikring",
  title: getText("stepper.housecontents.details-step1"),
  ariaLabel: `${MainPath.CHECK_PRICE}-din-innboforsikring`,
  complete: false,
};

export const HOUSE_CONTENTS_ABOUT_STEP: Step = {
  id: "om-boligen",
  title: getText("stepper.housecontents.details-step2"),
  ariaLabel: `${MainPath.CHECK_PRICE}-om-boligen`,
  complete: false,
};

export const HOUSE_CONTENTS_PRICE_STEP: Step = {
  id: "product-price",
  title: getText("stepper.commonsteps.checkprice"),
  ariaLabel: `${MainPath.CHECK_PRICE}-product-price`,
  complete: false,
};

export const HOUSE_CONTENTS_STEPS: Step[] = [
  HOUSE_CONTENTS_INTRO_STEP,
  HOUSE_CONTENTS_ABOUT_STEP,
  HOUSE_CONTENTS_PRICE_STEP,
  ...CHECKOUT_STEPS,
];
